import React from 'react'
import { ClipboardPlus } from 'react-bootstrap-icons'

const Enrollee = ({
    user = {},
    onClick = () => {}
}) => {

    return (
        <div
            
            style={{
                border: 'solid 1px rgb(187, 72, 63)',
                borderRadius: '5px',
                paddingLeft: '5px',
                padding: '5px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                margin: '5px'
            }}
        >
            {user.lastName}, {user.firstName}
            <ClipboardPlus
                color='rgb(66, 122, 54)'
                onClick={() => onClick()}
                size={25}
                style={{
                    cursor: 'pointer'
                }}
            />
        </div>
    )
}

export default Enrollee
